'use client';

import { useDeviceName } from 'lib/api/myRobot';

import { DeviceName } from 'types/models';

import { SpotControlActionKey } from '../../types/models/spot-control/SpotControl';
import { HUB_URL } from './const';
import { useSignalRHub } from './context/useSignalRHub';

export enum SpotcontrolHubEvents {
  SEND_SPOT_CONTROL_DATA = 'SendSpotControlData', // invoke
}

type SpotControlDataDTO = {
  deviceName: DeviceName;
  Key: string;
  Value: string;
};

/**
 * @type {spot_msgs.msg.BodyPose}
 */
export type RotationAxesDTO = {
  roll: number; // -1, 1
  pitch: number; // -1, 1
  yaw: number; // -1, 1
  height: number; // 0, 1
};

/**
 * Hook to use for the Spotcontrol hub
 */
export function useSpotcontrolHub() {
  const { deviceName } = useDeviceName();
  const hub = useSignalRHub(HUB_URL.SPOTCONTROL);

  function sendSpotPoseCommand(data: RotationAxesDTO) {
    return hub.invoke(SpotcontrolHubEvents.SEND_SPOT_CONTROL_DATA, {
      deviceName,
      Key: SpotControlActionKey.ROTATION_AXES,
      Value: JSON.stringify(data),
    } as SpotControlDataDTO);
  }

  return { ...hub, sendSpotPoseCommand };
}
